import * as env from "./env";

export const ROUTE_NOTES = `${env.REACT_APP_API_BASE}/notes`;
export const TIME_FORMAT = "dd MMM yyyy, EEE hh:mm aaa";
